import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchAuthorInfo: ['authorName'],
  fetchAuthorInfoStart: null,
  fetchAuthorInfoSuccess: ['authorData'],
  fetchAuthorInfoFailure: null,

  fetchAuthorPosts: ['authorName', 'pageNumber'],
  fetchAuthorPostsStart: null,
  fetchAuthorPostsSuccess: ['authorPosts'],
  fetchAuthorPostsFailure: null

  // increasePostCount: ['postId']
  // increasePostCountStart: null,
  // increasePostCountSuccess: ['topNews'],
  // increasePostCountFailure: null,
});

export { Types, Creators };
